import { apiCall } from './gqlClient';

const GETPROVIDERANALYTICS_QUERY = `
  query getProviderAnalytics {
    getProviderAnalytics
  }`;

export const getProviderAnalyticsApiCall = async () => apiCall({ query: GETPROVIDERANALYTICS_QUERY, variables: {}});
